import { TOfferCategory } from '../../../../types/offer';

export function getPaymentPeriod(category: TOfferCategory | null): string {
  return category && category.indexOf('daily') !== -1 ? 'сутки' : 'мес.';
}
